import { BaseDetail } from '@/domains/productDiscovery/ProductPage/interfaces/Detail.common.model';

import type { Market } from './Market';

export type MarketDetail<M extends Market = 'b2c' | 'b2b'> = BaseDetail;

export const getInitialState = <M extends Market>(): DetailState<M> => ({
  fetching: false,
  fetchingBasicDetail: false,
});

export interface ProductPageError {
  message: string;
  status: number;
  redirection: string | null;
}
export interface DetailState<M extends Market> {
  fetching: boolean;
  fetchingBasicDetail: boolean;
  error?: ProductPageError;
  data?: MarketDetail<M>;
  version?: 'V1' | 'V2-B2C' | 'V2-B2B';
}
